import { render } from "./accountProduct.vue?vue&type=template&id=f67758d6"
import script from "./accountProduct.vue?vue&type=script&lang=js"
export * from "./accountProduct.vue?vue&type=script&lang=js"

import "./accountProduct.vue?vue&type=style&index=0&id=f67758d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__